import { createColumn,createDropdownColumn } from "../components/Table/Table";

export const productColumns: State.Column[] = [
  createColumn(
    "Product number",
    (product: Api.KceProduct) => product.productNumber,
    "product.productNumber",
    true
  ),
  createColumn(
    "Product name",
    (product: Api.KceProduct) => product.productName,
    "product.productName",
    true
  ),
  createColumn("Comment", (product: Api.KceProduct) => product.comment, "product.comment", true)
];

export const versionColumns: State.Column[] = [
  createColumn("Number", (version: Api.KceVersion) => version.number, "version.number", true),
  createColumn("Name", (version: Api.KceVersion) => version.name, "version.name", true),
  createColumn("Comment", (version: Api.KceVersion) => version.comment, "version.comment", true)
];

export const doorVersionColumns: State.Column[] = [
  createColumn("Number", (version: Api.DoorVersion) => version.number, "version.number", true),
  createColumn("Name", (version: Api.DoorVersion) => version.versionName, "version.versionName", true),
  createColumn("Comment", (version: Api.DoorVersion) => version.description, "version.description", true),
    createDropdownColumn(
      "Domain",
      (version: Api.DoorVersion) => version.domainName,
      "driveVersion.domainName",
      true
    )
];  